import type { CaptureResult } from 'posthog-js';
import { redactCredentialsInUrl } from '@/Domain/utils/credentialRedaction';

// posthog-js stamps the page URL on every event, so a capture-site guard only ever covers the one event it guards.
const URL_PROPERTY_PATTERN = /(url|href|referrer)$/i;
// $elements entries sit two levels under properties; nothing we send is deeper.
const MAX_PROPERTY_DEPTH = 3;
// rrweb payloads are large and frequent, and the recorder's href handling is a session_recording concern.
const SNAPSHOT_EVENT = '$snapshot';

function redactContainerInPlace(container: Record<string, unknown>, depth: number): void {
  if (depth > MAX_PROPERTY_DEPTH) {
    return;
  }
  for (const [key, value] of Object.entries(container)) {
    if (typeof value === 'string') {
      if (URL_PROPERTY_PATTERN.test(key)) {
        container[key] = redactCredentialsInUrl(value);
      }
    } else if (value !== null && typeof value === 'object') {
      redactContainerInPlace(value as Record<string, unknown>, depth + 1);
    }
  }
}

export function redactUrlProperties(event: CaptureResult | null): CaptureResult | null {
  if (!event || event.event === SNAPSHOT_EVENT) {
    return event;
  }
  // $set/$set_once sit beside properties, not inside it, and carry $initial_current_url onto the person profile.
  for (const container of [event.properties, event.$set, event.$set_once]) {
    if (container) {
      redactContainerInPlace(container, 0);
    }
  }
  return event;
}
